(function () {
  'use strict';

  angular.module('eclipseApp.onboarding').controller('onboardingController', OnboardingController);

  OnboardingController.$inject = ['$scope',
    'restive',
    'onboardingService',
    'onlineBillingService'];

  function OnboardingController($scope,
                                restive,
                                onboardingService,
                                onlineBillingService) {
    var _this = this;
    init();

    _this.calculateProgress = function() {
      return  onboardingService.countCompletedTasks() / _this.itemConfigs.length * 100;
    };

    _this.onToggle = function() {
      _this.isCollapsed = !_this.isCollapsed;
      onboardingService.setToggleState(_this.isCollapsed);
    };

    _this.getProgressbarAltParam = function() {
      return { percent: _this.calculateProgress() };
    };

    _this.getToggleAltParam = function() {
      return { count: _this.itemConfigs.length };
    };

    _this.showCongratsMessage = function () {
      if (_this.calculateProgress() === 100) {
        onboardingService.setCongratsDisplayed();
        return true;
      } else {
        return false;
      }
    };

    function init() {
      _this.showOnboardingModule = false;
      _this.itemConfigs = onboardingService.getConfig();

      var savedToggleState = onboardingService.getToggleState();
      _this.isCollapsed = savedToggleState !== null ? savedToggleState : restive.isMobile();

      checkShowOnboardingModule();
    }

    function checkShowOnboardingModule() {
      onboardingService.setAccountDetails(_this.accountDetails);
      onboardingService.showOnboardingModule()
        .then(function (data) {
          _this.showOnboardingModule = data;
        });
    }


    //Unbind event from body when controller is destroyed
    $scope.$on('$destroy', function () {
      if (onboardingService.checkRegisteredToSmsRecoveryEvent()) {
        $('body').off('sms-recovery-phone-changed');
      }
      onlineBillingService.unsubscribeCallback('setOnlineBillingSubKey');
    });
  }

})();
